import styles from 'css/src/components/sketch/follow-on-actions/SketchWidget.module.scss';

import React from 'react';

import { PrimaryButton, TertiaryIconButton } from 'js/src/components/common/ui/Button';
import { Spinner } from 'js/src/components/common/ui/Spinner';

interface SketchWidgetProps {
    title?: string;
    titleClassName?: string;
    subtitle?: string;
    buttonText?: string;
    onClick?: () => void;
    buttonDisabled?: boolean;
    showDivider?: boolean;
    collapsible?: boolean;
    collapsed?: boolean;
    isLoading?: boolean;
    onToggleCollapse?: () => void;
    children?: React.ReactElement;
}

export const SketchWidget: React.FC<SketchWidgetProps> = ({
    title,
    titleClassName = 'font-l5 font-l5--regular--semibold',
    subtitle,
    buttonText = 'Apply',
    onClick,
    buttonDisabled,
    showDivider,
    collapsible,
    collapsed,
    isLoading,
    onToggleCollapse,
    children,
}) => {
    return (
        <div className={`${styles['sketch-widget']} p-l5-16`}>
            {title && (
                <div className={collapsible ? styles['sketch-widget__header'] : undefined}>
                    <div className={titleClassName}>{title}</div>
                    {collapsible && (
                        <TertiaryIconButton
                            icon={collapsed ? 'expand_content' : 'check_indeterminate_small'}
                            onClick={onToggleCollapse}
                        />
                    )}
                </div>
            )}
            <div
                className={`${styles['sketch-widget__body']}${collapsed ? ` ${styles['sketch-widget__body--collapsed']}` : ''}`}
            >
                <div className={styles['sketch-widget__body-inner']}>
                    {isLoading ? (
                        <div className={styles['sketch-widget__loading']}>
                            <Spinner size="sm" className="color-grey-500" />
                        </div>
                    ) : (
                        <>
                            {subtitle && (
                                <div className="font-l5 font-l5--small--medium mb-l5-12 color-grey-700">
                                    {subtitle}
                                </div>
                            )}
                            {children}
                            {showDivider && (
                                <hr
                                    className={`${styles['sketch-widget__divider']} mt-l5-16 mb-l5-0`}
                                />
                            )}
                            {onClick && (
                                <div className={`${styles['sketch-widget__cta']} mt-l5-16`}>
                                    <PrimaryButton
                                        text={buttonText}
                                        onClick={onClick}
                                        disabled={buttonDisabled}
                                    />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
